import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styles from '../../css/RegisterPage.module.css';

const Register = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    companyName: '',
    companyDetails: '',
  });

  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        'https://techservicemarket-backend.onrender.com/api/recruiter/register',
        formData
      );
      setSuccessMessage(response.data.message); // Success message from backend
      setError('');
      navigate('/recruiter/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong!');
      setSuccessMessage('');
    }
  };

  return (
    <div className={styles.registerContainer}>
      <h2 className={styles.registerHeader}>Register as Recruiter</h2>
      {error && <div className={styles.errorMessage}>{error}</div>}
      {successMessage && <div className={styles.successMessage}>{successMessage}</div>}
      <form onSubmit={handleSubmit} className={styles.registerForm}>
        <input
          type="text"
          name="username"
          placeholder="Username"
          value={formData.username}
          onChange={handleChange}
          required
          minLength="3"
          className={styles.inputField}
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
          className={styles.inputField}
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
          className={styles.inputField}
        />
        <input
          type="text"
          name="companyName"
          placeholder="Company Name"
          value={formData.companyName}
          onChange={handleChange}
          required
          minLength="2"
          className={styles.inputField}
        />
        <textarea
          name="companyDetails"
          placeholder="Company Details"
          value={formData.companyDetails}
          onChange={handleChange}
          className={styles.textAreaField}
        />
        <button type="submit" className={styles.submitButton}>
          Register
        </button>
      </form>
    </div>
  );
};

export default Register;
